module.exports = __webpack_public_path__ + "img/live_wm.d941346d.png";